// 数据采集
import Log from "../view/log";
import QuestionnaireNav from "../view/Questionnaire/QuestionnaireNav";
import TemplateManage from "../view/Questionnaire/TemplateManage/TemplateManage";
import TemplateManageAdd from "../view/Questionnaire/TemplateManage/TemplateManageAdd";
import TemplateManageModify from "../view/Questionnaire/TemplateManage/TemplateManageModify";
import QuestionnaireProjectManage from "../view/Questionnaire/QuestionnaireProject/QuestionnaireProjectManage";
import QuestionnaireProjectAdd from "../view/Questionnaire/QuestionnaireProject/QuestionnaireProjectAdd";
import QuestionnaireProjectModify from "../view/Questionnaire/QuestionnaireProject/QuestionnaireProjectModify";
import QuestionnairePublishmentManage from "../view/Questionnaire/QuestionnairePublish/QuestionnairePublishmentManage";
import QuestionnairePublishmentAdd from "../view/Questionnaire/QuestionnairePublish/QuestionnairePublishmentAdd";
import QuestionnairePublishmentModify from "../view/Questionnaire/QuestionnairePublish/QuestionnairePublishmentModify";

export default [
  {
    path: "/questionnaire_template_manage",
    name: "questionnaire-template-manage",
    components: {
      default: QuestionnaireNav,
      a: TemplateManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/questionnaire_template_manage_add",
    name: "questionnaire-template-add",
    components: {
      default: QuestionnaireNav,
      a: TemplateManageAdd
    }
  },
  {
    path: "/questionnaire_template_manage_modify/:id",
    name: "questionnaire-template-modify",
    components: {
      default: QuestionnaireNav,
      a: TemplateManageModify
    }
  },
  {
    path: "/questionnaire_project_manage",
    name: "questionnaire-project-manage",
    components: {
      default: QuestionnaireNav,
      a: QuestionnaireProjectManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/questionnaire_project_add",
    name: "questionnaire-project-add",
    components: {
      default: QuestionnaireNav,
      a: QuestionnaireProjectAdd
    }
  },
  {
    path: "/questionnaire_project_modify/:id",
    name: "questionnaire-project-modify",
    components: {
      default: QuestionnaireNav,
      a: QuestionnaireProjectModify
    }
  },
  {
    path: "/questionnaire_publishment_manage",
    name: "questionnaire-publishment-manage",
    components: {
      default: QuestionnaireNav,
      a: QuestionnairePublishmentManage
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/questionnaire_publishment_add",
    name: "questionnaire-publishment-add",
    components: {
      default: QuestionnaireNav,
      a: QuestionnairePublishmentAdd
    }
  },
  {
    path: "/questionnaire_publishment_modify/:id",
    name: "questionnaire-publishment-modify",
    components: {
      default: QuestionnaireNav,
      a: QuestionnairePublishmentModify
    }
  },
  {
    path: "/questionnaire_publishment_modify/:id",
    name: "questionnaire-publishment-modify",
    components: {
      default: QuestionnaireNav,
      a: QuestionnairePublishmentModify
    }
  },
  // 数据采集操作日志
  {
    path: "/questionnaire_log",
    name: "questionnaire-log",
    components: {
      default: QuestionnaireNav,
      a: Log
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/Questionnaire.js